import React, {
  useEffect,
  useState,
} from 'react';
import { node } from 'prop-types';
import { ABContext } from '../../contexts/ABContext';
import isABTest from '../../ab/isabtest';

export const ABContextProvider = ({ children }) => {
  const [abTests, setABTests] = useState({});

  useEffect(() => {
    // const HOT637IsVariant = isABTest('HOT-637-DLP-Park-Ticket-step-v3');

    // Add context
    const testHOT637 = ({
      HOT637: {
        name: 'HOT-637-DLP-Park-Ticket-step-v3',
        // variant: HOT637IsVariant,
        variant: 0,
      },
    });

    // Update state
    setABTests((prevState) => ({ ...prevState, ...testHOT637 }));
  }, []);

  return (
    <ABContext.Provider value={abTests}>{ children }</ABContext.Provider>
  );

  // CRO-000-test = example cro test
  // // comment/uncomment this line to make test pause/work:
  //     const cro000IsVariant = isABTest('CRO-000-test-name');

  // // Add context
  //     const testCro000 = ({
  //       cro000: {
  //         name: 'CRO-000-test-name',
  //         // comment/uncomment this line to make test pause/work:
  //         variant: cro000IsVariant,
  //         // uncomment this if we want to pause test:
  //         // variant: 0,
  //       },
  //     });

  //   // Update state
  //   setABTests((prevState) => ({ ...prevState, ...testCRO000 }));
  // }, []);

  // return (
  //   <ABContext.Provider value={abTests}>{ children }</ABContext.Provider>
  // );
  // End CRO-000-test = example cro test
};

ABContextProvider.propTypes = {
  children: node.isRequired,
};

ABContextProvider.defaultProps = {};

export default ABContextProvider;
